module.exports = __webpack_public_path__ + "img/dingwei@3x.1837cc42.png";